import Vue from 'vue'
import Router from 'vue-router'
import {
  Cameras,
  Rbpi,
  Provinces,
  Regions,
  Countries,
  Towns,
  Roles,
  Categories,
  TypeEvents,
  TypeSubscription,
  Home,
  ControlPanel,
  Users,
  UsersBulkCreate,
  Languages,
  Matches,
  // Trainings,
  Entities,
  Stadiums,
  Notifications,
  Teams,
  Login,
  LostPassword,
  Tournaments,
  TermsOfUse,
  TermsAndConditions,
  Cookies,
} from '@/helpers/routeDirect'

import {
  Matches2,
  MatchForm,
  MatchView,
  MatchList,
  SubscriptionList,
  TrainingList,
  TrainingForm,
  TrainingView,
  // Login,
  // LostPassword
} from '@/helpers/routeLazyLoad'
import store from '@/store/store'

Vue.use(Router)
export const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Home,
      meta: { requiresAuth: true, breadcrumb: true },
    },
    {
      path: '/control-panel',
      name: 'control-panel',
      component: ControlPanel,
      meta: { requiresAuth: true },
    },
    {
      path: '/management/users',
      name: 'users',
      component: Users,
      meta: { requiresAuth: true, breadcrumb: true },
    },
    {
      path: '/management/users/bulk-create',
      name: 'bulk-create-users',
      component: UsersBulkCreate,
      props: (route) => ({
        entityId: route.params.entityId || route.query.entityId,
      }),
      meta: { requiresAuth: true, fullscreen: true },
    },
    {
      path: '/apps/tournaments',
      name: 'tournaments',
      component: Tournaments,
      meta: { requiresAuth: true, breadcrumb: true },
    },
    {
      path: '/apps/notifications',
      name: 'notifications',
      component: Notifications,
      meta: { requiresAuth: true, breadcrumb: true },
    },
    {
      path: '/apps/matches',
      name: 'matches',
      component: Matches,
      meta: { requiresAuth: true, breadcrumb: true },
    },
    {
      path: '/matches',
      component: Matches2,

      props: true,
      children: [
        {
          path: '',
          name: 'matches2',
          component: MatchList,
          props: true,
        },
        {
          path: 'create',
          name: 'match-create',
          component: MatchForm,
          props: true,
        },
        {
          path: ':id',
          name: 'match-edit',
          component: MatchForm,
          props: true,
        },
        {
          path: ':id/view',
          name: 'match-view',
          component: MatchView,

          props: true,
        },
      ],
    },
    // {
    //   path: '/apps/trainings',
    //   name: 'trainings',
    //   component: Trainings,
    //   meta: { requiresAuth: true, breadcrumb: true }
    // },
    {
      path: '/trainings',
      name: 'trainings',
      component: TrainingList,
      meta: { requiresAuth: true },
    },
    {
      path: '/trainings/:action(create|edit)/:id?',
      name: 'training-form',
      component: TrainingForm,
      meta: { requiresAuth: true, fullscreen: true },
      props: true,
    },
    {
      path: '/trainings/view/:id',
      name: 'training-view',
      component: TrainingView,
      meta: { requiresAuth: true, fullscreen: true },
      props: true,
    },
    {
      path: '/management/entities',
      name: 'entities',
      component: Entities,
      meta: { requiresAuth: true, breadcrumb: true },
    },
    {
      path: '/management/stadiums',
      name: 'stadiums',
      component: Stadiums,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/management/subscriptions',
      name: 'subscriptions',
      component: SubscriptionList,
      meta: { requiresAuth: true },
    },
    {
      path: '/management/teams',
      name: 'teams',
      component: Teams,
      meta: { requiresAuth: true, breadcrumb: true },
    },

    // {
    //   path: '/teams/acceptInvitation/:teamId/:tournamentId/:tk',
    //   name: 'acceptInvitation',
    //   component: AcceptInvitation,
    //   props: true
    // },
    // {
    //   path: '/managements/courses',
    //   name: 'courses',
    //   component: Courses,
    //   meta: { requiresAuth: true, breadcrumb: true }
    // },
    {
      path: '/config/cameras',
      name: 'cameras',
      component: Cameras,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/raspberry-pi',
      name: 'raspberry-pi',
      component: Rbpi,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/typesSubscription',
      name: 'typeSubscription',
      component: TypeSubscription,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/categories',
      name: 'categories',
      component: Categories,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/roles',
      name: 'roles',
      component: Roles,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/towns',
      name: 'towns',
      component: Towns,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/countries',
      name: 'countries',
      component: Countries,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/regions',
      name: 'regions',
      component: Regions,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/provinces',
      name: 'provinces',
      component: Provinces,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/languages',
      name: 'languages',
      component: Languages,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    {
      path: '/config/typeEvents',
      name: 'typeEvents',
      component: TypeEvents,
      meta: { requiresAuth: true, breadcrumb: true, admin: true },
    },
    // {
    //   path: '/config/profile',
    //   name: 'profile',
    //   component: Profile,
    //   meta: { requiresAuth: true, breadcrumb: true }
    // },
    // {
    //   path: '/video',
    //   name: 'video',
    //   component: VideoPlayer,
    //   meta: { requiresAuth: true, breadcrumb: true }
    // },
    // {
    //   path: '/youtube',
    //   name: 'youtube',
    //   component: YoutubePlayer,
    //   meta: { requiresAuth: true, breadcrumb: true }
    // },
    // {
    //   path: '/tabEvents',
    //   name: 'tabEvents',
    //   component: TabEvents,
    //   meta: { requiresAuth: true, breadcrumb: true }
    // },
    // Auth routes
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false },
    },
    {
      path: '/lostPassword',
      name: 'lostPassword',
      component: LostPassword,
      meta: { requiresAuth: false },
    },

    {
      path: '/terms-of-use',
      redirect: '/terms-of-use/es',
    },
    {
      path: '/terms-of-use/:locale',
      name: 'terms-of-use',
      component: TermsOfUse,
    },
    {
      path: '/terms-and-conditions',
      redirect: '/terms-and-conditions/es',
    },
    {
      path: '/terms-and-conditions/:locale',
      name: 'terms-and-conditions',
      component: TermsAndConditions,
    },
    {
      path: '/cookies',
      redirect: '/cookies/es',
    },
    { path: '/cookies/:locale', name: 'cookies', component: Cookies },
    // {
    //   path: '/lostPassword/:userId/:tk',
    //   name: 'resetPassword',
    //   component: ResetPassword,
    //   props: true
    // },

    // otherwise redirect to home
    { path: '*', redirect: '/dashboard' },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta.admin) {
    let isAdmin = store.state.auth.roles.some(
      (role) => role.confirm && role.roleId && role.roleId.type === 'all'
    )
    if (!isAdmin) return next('dashboard')
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const loggedIn = localStorage.getItem('user')
    if (!loggedIn) {
      return next('login')
    }
  } else if (to.matched.some((record) => record.meta.requiresAuth === false)) {
    const loggedIn = localStorage.getItem('user')
    if (loggedIn) {
      return next('dashboard')
    }
  }
  to.params.from = { name: from.name, params: { ...from.params, from: null } }
  return next()
})

// router.beforeEach((to, from, next) => {
//   // redirect to login page if not logged in and trying to access a restricted page
//   const publicPages = ['/login'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   if (authRequired && !loggedIn) {
//     return next('/login');
//   }

//   next();
// })
